import { createSlice } from "@reduxjs/toolkit";
import { getAgencyCampaignList } from "./thunk";

export interface IState {
  lstCampaign: any;
  isCampaignLoading: boolean;
  isCampaignSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  lstCampaign: null,
  isCampaignLoading: false,
  isCampaignSuccess: false,

  error: {},
};

const AgencySlice = createSlice({
  name: "Agency",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get Advertisements
    builder.addCase(getAgencyCampaignList.pending, (state: IState, action: any) => {
      state.isCampaignLoading = true;
    });
    builder.addCase(
      getAgencyCampaignList.fulfilled,
      (state: IState, action: any) => {
        state.lstCampaign = action.payload.data;
        state.isCampaignSuccess = true;
        state.isCampaignLoading = false;
      }
    );
    builder.addCase(
      getAgencyCampaignList.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isCampaignSuccess = false;
        state.isCampaignLoading = false;
      }
    );
  },
});

export default AgencySlice.reducer;